<template>
  <SGPRowComponent>
    <SGPColComponent cols="12" class="mt-5">
      <div>
        <ClassificarTicketComponent
          v-if="exibirClassificacao"
          :pcoTarefaId="dadosFichaTecnica.id"
          @classificado="onTicketClassificado"
          :dadosFichaTecnica="dadosFichaTecnica"
        />

        <SGPAlertaComponent v-if="tarefaFinalizada" type="danger" class="mb-4">
          <h5>Tarefa Finalizada</h5>
          Esta tarefa foi finalizada e não pode sofrer nenhuma tratativa.
        </SGPAlertaComponent>

        <SGPAlertaComponent v-if="tarefaTipoInterrupcao" type="danger" class="mb-4">
          <h5>Tarefa de Interrupção</h5>
          Tarefas de interrupção não podem sofrer tratativas.
        </SGPAlertaComponent>

        <SGPAlertaComponent v-if="tarefaInterrompida && !tarefaFinalizada && !tarefaTipoInterrupcao" type="danger" class="mb-4">
          <h5>Tarefa Interrompida</h5>
          Esta tarefa está interrompida e não pode sofrer nenhuma tratativa. Resolva a interrupção para continuar.
        </SGPAlertaComponent>

        <SGPAlertaComponent v-if="exibirClassificacao" type="warning" class="mb-4">
          <h5>Classificação obrigatória</h5>
          Complete os campos pendentes de classificação (provedor e/ou designação) para habilitar as demais tratativas desta tarefa.
        </SGPAlertaComponent>

        <div class="mt-4 mb-4 d-flex" v-if="!tarefaFinalizada && !tarefaTipoInterrupcao && !exibirClassificacao">
          <SGPFormBotaoComponent v-if="estadoTratativa.podeLiberar" @click="liberar" class="mr-4" color="primary">
            Liberar Tarefa
          </SGPFormBotaoComponent>

          <!-- <SGPFormBotaoComponent v-if="estadoTratativa.podeContinuar" @click="continuarTratamento" color="black"
            outlined class="mr-4">
            Continuar Tratamento
          </SGPFormBotaoComponent> -->

          <SGPFormBotaoComponent v-if="estadoTratativa.podeIniciarTratativa" @click="abrirModalTratativas" class="mr-4"
            color="primary">
            Iniciar tratativa
          </SGPFormBotaoComponent>

          <SGPFormBotaoComponent v-if="estadoTratativa.podeApropriar" @click="apropriar" class="mr-2" color="primary">
            Apropriar
          </SGPFormBotaoComponent>

          <SGPModalComponent v-model="modalTratativaAberto" tamanho="xl" titulo="Tratativa" :mostrarFooter="false"
            v-if="modalTratativaAberto" @sgpModalFechar="fecharModalTratativa"
            @sgpModalMinimizar="criarCookieFormulario" minimizar>
            <TratativaComponent :tratativas="listaTratativas" :pco_tarefa="tarefaAtual"
              @salvandoFormularioDinamico="atualizarFormularioDinamico"
              @conteudoFormularioDinamicoEmit="conteudoFormulario"
              @tratativaExecutada="fecharModalTratativa" />
          </SGPModalComponent>
        </div>
      </div>
    </SGPColComponent>

    <v-btn color="second" style="z-index: 99999999;" fab fixed dark right bottom small v-b-tooltip.left
      title="Continuar Tratamento" class="margin-bottom-10" v-if="!modalTratativaAberto && possueCacheSalvo && !tarefaInterrompida && !tarefaFinalizada && !tarefaTipoInterrupcao && !exibirClassificacao"
      @click="continuarTratamento">
      <v-icon>mdi-list-box</v-icon>
    </v-btn>
  </SGPRowComponent>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TratativaComponent from './TratativaComponent.vue'
import ClassificarTicketComponent from './ClassificarTicketComponent.vue'
import EventBus from '@/common/helpers/EventBus'
import { getProvedorAtivoId } from '../../helpers/provedorHelper'

export default {
  name: "AcoesTratativasComponent",
  components: {
    TratativaComponent,
    ClassificarTicketComponent
  },

  props: {
    dadosFichaTecnica: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      modalTratativaAberto: false,
      formularioDinamico: {},
      possueCacheSalvo: false,
      tarefaInterrompidaLocal: false
    }
  },

  created() {
    this.verificarTarefaInterrompida();
  },

  computed: {
    ...mapGetters('fichaTecnicaWorkflow', [
      'listaTratativas'
    ]),

    usuarioLogado() {
      const cache = localStorage.getItem('provedores-usuario');
      return cache ? JSON.parse(cache) : null;
    },

    tarefaAtual() {
      return this.dadosFichaTecnica?.pco_tarefa || this.dadosFichaTecnica || {};
    },

    ctrlTarefaId() {
      return this.dadosFichaTecnica?.ctrl_tarefa?.id ||
        this.tarefaAtual?.ctrl_tarefa?.id ||
        null;
    },

    tarefaAdotada() {
      return this.tarefaAtual?.user_tratamento_id !== null;
    },

    tarefaInterrompida() {
      return this.tarefaAtual?.pco_tarefa_interrupcao_id !== null;
    },

    tarefaFinalizada() {
      return this.tarefaAtual?.finalized_at !== null;
    },

    tarefaTipoInterrupcao() {
      return this.tarefaAtual?.ctrl_tarefa?.tipo_tarefa?.tipo === 'Interrupção';
    },

    apropriarTarefaUsuario() {
      return this.tarefaAdotada &&
        this.tarefaAtual?.user_tratamento_id !== this.usuarioLogado?.id;
    },

    tarefaAdotadaPeloUsuario() {
      return (
        this.usuarioLogado &&
        this.tarefaAtual?.user_tratamento_id === this.usuarioLogado.id
      );
    },

    estadoTratativa() {
      if (!this.dadosFichaTecnica || this.tarefaFinalizada || this.tarefaTipoInterrupcao) return {};

      const base = !this.tarefaInterrompida && !this.tarefaFinalizada && !this.tarefaTipoInterrupcao;
      const podeIniciarOuReabrir =
        (!this.tarefaAdotada || this.tarefaAdotadaPeloUsuario) && base;

      return {
        podeIniciarTratativa: podeIniciarOuReabrir,

        podeApropriar: this.apropriarTarefaUsuario && base,

        podeLiberar: this.tarefaAdotadaPeloUsuario && base,
      };
    },

    exibirClassificacao () {
      const ctrlTarefa = this.dadosFichaTecnica?.ctrl_tarefa
      const ehTarefaClassificar = ctrlTarefa?.map === 'DS101-T'

      if (!ehTarefaClassificar || this.tarefaFinalizada) {
        return false
      }

      const provedorRecuperacao = this.dadosFichaTecnica?.workflow?.provedor_recuperacao || {}
      const faltaProvedor = !provedorRecuperacao.ctrl_provedor_id
      const faltaDesignacao = !provedorRecuperacao.designacao_claro

      return faltaProvedor || faltaDesignacao
    }
  },

  methods: {
    ...mapActions('fichaTecnicaWorkflow', [
      'adotarTarefa',
      'devolverTarefa',
      'apropriarTarefa',
      'buscarDadosFichaTecnicaTarefa',
      'liberarTarefa',
      'tratativasPorCtrlTarefa'
    ]),

    verificarTarefaInterrompida() {
      this.tarefaInterrompidaLocal = this.tarefaInterrompida;
    },

    async onTicketClassificado () {
      await this.buscarDadosFichaTecnicaTarefa(this.$route.params.pco_tarefa_id)
    },

    async abrirModalTratativas() {
      if (this.exibirClassificacao) {
        return;
      }
      if (!this.ctrlTarefaId) {
        console.error('ID da ctrl_tarefa não disponível');
        return;
      }

      await this.$nextTick();

      if (!this.tarefaAdotadaPeloUsuario) {
        await this.adotar();
      }

      await this.tratativasPorCtrlTarefa(this.ctrlTarefaId);
      await this.$nextTick();

      this.modalTratativaAberto = true;
    },

    fecharModalTratativa() {
      this.modalTratativaAberto = false;
      localStorage.removeItem(process.env.VUE_APP_FORMULARIO_DINAMICO_MINIMIZADO);
    },

    continuarTratamento() {
      if (this.exibirClassificacao) {
        return;
      }

      this.modalTratativaAberto = true;
    },

    async adotar() {
      const ticketId = getProvedorAtivoId(this.dadosFichaTecnica?.workflow);
      await this.adotarTarefa(this.$route.params.pco_tarefa_id);
      await this.buscarDadosFichaTecnicaTarefa(this.$route.params.pco_tarefa_id);
      if (ticketId) {
        EventBus.$emit('tratativaAtualizada', ticketId);
      }
    },

    async devolverParaFila() {
      const ticketId = getProvedorAtivoId(this.dadosFichaTecnica?.workflow);
      await this.devolverTarefa(this.$route.params.pco_tarefa_id);
      await this.buscarDadosFichaTecnicaTarefa(this.$route.params.pco_tarefa_id);
      if (ticketId) {
        EventBus.$emit('tratativaAtualizada', ticketId);
      }
    },

    async liberar() {
      const ticketId = getProvedorAtivoId(this.dadosFichaTecnica?.workflow);
      await this.liberarTarefa(this.$route.params.pco_tarefa_id);
      await this.buscarDadosFichaTecnicaTarefa(this.$route.params.pco_tarefa_id);
      if (ticketId) {
        EventBus.$emit('tratativaAtualizada', ticketId);
      }
    },

    async apropriar() {
      const ticketId = getProvedorAtivoId(this.dadosFichaTecnica?.workflow);
      await this.apropriarTarefa(this.$route.params.pco_tarefa_id);
      await this.buscarDadosFichaTecnicaTarefa(this.$route.params.pco_tarefa_id);
      if (ticketId) {
        EventBus.$emit('tratativaAtualizada', ticketId);
      }
    },

    atualizarFormularioDinamico() {
      this.$emit("atualizaFormularioDinamico");
    },

    conteudoFormulario(form) {
      this.formularioDinamico = form;
    },

    criarCookieFormulario() {
      this.modalTratativaAberto = false;
      localStorage.setItem(
        process.env.VUE_APP_FORMULARIO_DINAMICO_MINIMIZADO,
        JSON.stringify(this.formularioDinamico)
      );
    }
  },

  watch: {
    ctrlTarefaId: {
      async handler(ctrlTarefaId) {
        if (!ctrlTarefaId) return;
        await this.tratativasPorCtrlTarefa(ctrlTarefaId);
      },
      immediate: true
    },

    modalTratativaAberto() {
      this.possueCacheSalvo = false;
      const cache = localStorage.getItem(process.env.VUE_APP_FORMULARIO_DINAMICO_MINIMIZADO);
      if (cache) {
        this.possueCacheSalvo = true;
      }
    },

    dadosFichaTecnica: {
      handler() {
        this.verificarTarefaInterrompida();
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.manter-bloco .v-input--checkbox {
  margin-top: 0 !important;
}
</style>
